module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/recurring/artwork-cef2e3d37502f2e8adebc0e2f2b45eab.svg";